export default window;
